import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Keyboard,
    Autoplay,
    EffectFade,
} from 'swiper/modules';

import AOS from 'aos';
  
Swiper.use([Navigation, Pagination, Keyboard, Autoplay, EffectFade]);

const navigation = (target) => {
    return {
        nextEl: `.${target}-swiper-button--next`,
        prevEl: `.${target}-swiper-button--prev`,
    };
};
  
$(window).on('load', function () {
    swipers();
});
  
const swipers = () => {
    postsSwiper();
    storiesSwiper();
    filterItems();
    memberSwiper();
    rwImages();
    imageSwiper();
    relatedSwiper();
    floorplanSwiper();
};

const relatedSwiper = () => {
    return new Swiper('.rw-related__swiper', {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 1.2,
        navigation: navigation('rw-related__swiper__nav'),
        breakpoints: {
            1200: {
                slidesPerView: 3.1,
            },
            992: {
                slidesPerView: 2.2,
            },
            768: {
                slidesPerView: 1.5,
            },
        },
    });
};

const imageSwiper = () => {
    return new Swiper('.image-swiper', {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: navigation('image-swiper__footer__nav'),
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    });
};

const floorplanSwiper = () => {
    return new Swiper('.floorplan-swiper', {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: navigation('floorplan-swiper__footer__nav'),
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    });
};

const filterItems = () => {
    return new Swiper('.post-filter__items', {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 'auto',
    });
};

const postsSwiper = () => {
    return new Swiper('.module--posts__items', {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 1.2,
        navigation: navigation('module--posts__nav'),
        breakpoints: {
            1200: {
                slidesPerView: 2.5,
            },
            992: {
                slidesPerView: 2.2,
            },
            768: {
                slidesPerView: 1.5,
            },
        },
    });
};

const storiesSwiper = () => {
    return new Swiper('.module--stories__items--story', {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1,
        allowTouchMove: false,
        navigation: navigation('module--stories__nav--story'),
    });
};

const memberSwiper = () => {
    return new Swiper('.module--stories__items--member', {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1,
        allowTouchMove: false,
        navigation: navigation('module--stories__nav--member'),
    });
};

const rwImages = () => {
    return new Swiper('.rw-images', {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 1.2,
        navigation: navigation('rw-images__footer__nav'),
        breakpoints: {
            768: {
                slidesPerView: 'auto',
            },
        },
    });
};


$(document).ready(function() {
    $( '.module--slider__images' ).each(function() {
        const swiperId = $(this).attr('data-id');

        return new Swiper('.module--slider__images.'+swiperId, {
            loop: false,
            spaceBetween: 0,
            slidesPerView: 1.2,
            navigation: navigation(swiperId),
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
            },
            on: {
                init: function() {
                    if($('.controls-'+swiperId+' .swiper-button-disabled').length == 2) {
                        $('.controls-'+swiperId).removeClass('d-md-flex');
                    }
                },
            },
        });
    });
});

$(window).on('resize', function () {
    AOS.refresh();
});
